module.exports = __webpack_public_path__ + "static/img/Exp-DHL.abc15ffe.png";